import CIcon from "@coreui/icons-react";
import { CSidebar, CSidebarHeader, CSidebarNav } from "@coreui/react";
import React from "react";
import "../commonStyle.css";

/**
 * @function ReportManager_Sidebar
 * @description for ReportManager_Sidebar
 * @returns JSX for ReportManager_Sidebar
 */

const ReportManager_Sidebar = ({ modeHandler, mode, modes }) => {
  return (
    <CSidebar size="sm" className="c-sidebar">
      <CSidebarHeader
        className="border-bottom pt-0 pb-0"
        style={{ paddingLeft: "25px" }}
      >
        <p className="mb-0 sidebar-head-text">{"All Reports"}</p>
      </CSidebarHeader>
      <CSidebarNav className="c-sidebar-nav">
        {modes &&
          modes.map((item, i) => {
            return (
              <span
                key={item.id || i}
                className={`cursor-pointer c-sidebar-nav-link ${mode === item.value ? "c-sidebar-nav-link-selected" : ""}`}
                onClick={() => modeHandler(item.value)}
              >
                <CIcon customClassName="" icon={item.icon} size="lg" />
                {item.value}
              </span>
            );
          })}
      </CSidebarNav>
    </CSidebar>
  );
};

export default React.memo(ReportManager_Sidebar);
